import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { FloatingWhatsApp } from "@/components/site/FloatingWhatsApp";
import { Packages } from "@/components/site/Packages";
import SEO from "@/components/SEO";
import { useLocation } from "react-router-dom";

export default function PackageListing() {
  const location = useLocation();

  let city = "Semua";

  if (location.pathname === "/paket-umroh-batam") {
    city = "Batam";
  }

  if (location.pathname === "/paket-umroh-palembang") {
    city = "Palembang";
  }

let seoTitle = "Paket Umroh Baba Tour";
let seoDescription =
  "Pilihan paket umroh keberangkatan Batam dan Palembang dengan berbagai jadwal dan fasilitas terbaik.";

if (city === "Batam") {
  seoTitle = "Paket Umroh Batam | Baba Tour";
  seoDescription =
    "Paket umroh keberangkatan Batam dengan berbagai pilihan jadwal, maskapai, hotel dan fasilitas terbaik.";
}

if (city === "Palembang") {
  seoTitle = "Paket Umroh Palembang | Baba Tour";
  seoDescription =
    "Paket umroh keberangkatan Palembang dengan berbagai pilihan jadwal, maskapai, hotel dan fasilitas terbaik.";
}

let canonical =
  "https://babatourumroh.com/paket-umroh";

if (city === "Batam") {
  canonical =
    "https://babatourumroh.com/paket-umroh-batam";
}

if (city === "Palembang") {
  canonical =
    "https://babatourumroh.com/paket-umroh-palembang";
}

  return (
    <div className="bg-[color:var(--bg)] text-main overflow-x-hidden">
      <Header />
<SEO
  title={seoTitle}
  description={seoDescription}
  canonical={canonical}
/>
      <main>
        <Packages layout="grid" defaultCity={city} />
      </main>

      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
